const HeaderCard = ({ primaryText, secondaryText, icon, statusText }) => {
    return (
        <>
            <div className="flex flex-row items-center justify-center">
                <div className="flex flex-row items-center gap-2 min-w-[120px] 2xl:min-w-[175px] overflow-hidden">
                    <div className="h-8 w-8 md:h-8 md:w-8 2xl:h-10 2xl:w-10 rounded-full bg-[#748ADF26] bg-opacity-30 flex justify-center items-center">
                        {icon ? <img className="h-4 w-4 md:w-4 md:h-4 2xl:w-5 2xl:h-5 float-left object-contain" src={icon} alt="NA" /> : '--'}
                    </div>
                    <div className=" felx justify-center items-center">
                        <div className="text-xs md:text-xs 2xl:text-base font-semibold text-primaryText whitespace-nowrap flex items-center gap-4">
                            {primaryText ? primaryText : "--"}
                            {statusText != null &&
                                <p className={`${statusText === true ? "bg-alertSuccess" : "bg-alertError"} h-4 md:h-4 2xl:h-4 flex items-center text-labels text-[10px] 2xl:text-[12px] rounded-full px-2`}>{statusText === true ? 'Live' : statusText === false ? 'Unlive' : ''}</p>
                            }
                        </div>
                        <div className="text-xs md:text-xs 2xl:text-base text-secondaryText">{secondaryText ? secondaryText : "--"}</div>
                    </div>
                </div>
            </div >
        </>
    )
}

// Skip prop validation by setting propTypes to null
HeaderCard.propTypes = null;

export default HeaderCard